export default "__VITE_ASSET__e127d06e__"